const indestriesdata = [
    {
        id: 1,
        title: 'Healthcare',
        imgurl:require('../../images/healthcare.jpg'),
        disc: 'Our certified development experts use only trusted technologies for delivering back-end, front-end, cloud, AI, and other software solutions.'
    },
    {
        id: 2,
        title: 'Finance & Banking',
        imgurl: require('../../images/fintech.jpg'),
        disc: 'That’s why we’re going to take a close look at 15 blog examples. These blogs all have unique strengths that will help support you as you develop your own, no matter what topics you plan to cover.'
    },

    {
        id: 3,
        title: 'Education',
        imgurl: require('../../images/education.jpg'),
        disc: 'That’s why we’re going to take a close look at 15 blog examples. These blogs all have unique strengths that will help support you as you develop your own, no matter what topics you plan to cover.'
    },
    {
        id: 4,
        title: 'Media & Advertising',
        imgurl: require('../../images/media.jpg'),
        disc: 'That’s why we’re going to take a close look at 15 blog examples. These blogs all have unique strengths that will help support you as you develop your own, no matter what topics you plan to cover.'

    }
]


export default indestriesdata